import {
    request,
    requestPublic
} from './request.js'
// 获取院校列表
export function getSchoolList(obj) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/SchoolPagination',
        method: 'get',
        params: {
            PageSize : obj.pageSize,
            PageNumber  : obj.pageNumber,
            Category : obj.category,
            Name : obj.name
        }
    })
}

// 获取院校详情
export function getSchoolDetails(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/GetSchool',
        method: 'get',
        params: {
            id: id
        }
    })
}

// 添加院校
export function addSchool(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/AddSchool',
        method: 'post',
        data: data
    })
}

// 修改院校
export function modifySchool(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/ModifySchool',
        method: 'post',
        data: data
    })
}

// 删除院校
export function removeSchool(id) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/RemoveSchool',
        method: 'post',
        params: {
            id: id
        }
    })
}

// 获取院校列表 不分页 用于编辑初始化
export function getSchoolEditorList(data) {
    return request({
        url: '/api2/ZsbSiteAdmin/School/SchoolList',
        method: 'post',
        data:data
    })
}